/* ============================================================
   NORTHSHEEP — A closer look: the card, enlarged, floating over the collection
   TRIAL (owner, 30 Sep 2026), behind Theme settings -> "Large view on phones".

   "replace the add to cart button with this enlarge button instead and then
   when they enlarge the cart they can add it to cart from this enlarged
   screen" / "really make it a floating enlarged cart look so below and above
   you can still see a bit of the collection so people know they didnt
   accidently open a new page" / "view/add to cart/x" / "no annoying jumps or
   scrolls ... the collection behind stays exactly where it is".

   THE REAL CARD, NOT A COPY. The tapped card itself is lifted out of the grid
   into a floating frame and put back on close, so everything on it keeps
   working exactly as on the grid: its add-to-basket form, the size pills and
   their prices (ns-variant-price.js), the favourite heart and the basket
   state (ns-card-cart-state.js). A copy would have duplicated the form's id
   and lost every listener bound to the original. Its place in the grid keeps
   its exact height while it is out, so nothing on the page moves.

   Under the enlarged card: View (the product page) · Add to basket · ×.
     single  one variant: the card's own add button is the Add.
     pick    one option: the size pill or colour thumbnail chosen on the card
             is what gets added. A colour is chosen with one tap (the photo
             switches to it); a second tap on it opens that colour's page,
             the same two taps the size pills already use.
     view    two or more options: only the product page can ask, so View · ×.
   Closes with ×, a tap on the dimmed collection, Escape or the phone's back
   gesture (one history entry, so Back closes it instead of leaving the page),
   and when the shopper comes back to it from the product page (pageshow).
   ============================================================ */
(function () {
  'use strict';
  if (window.__nsCardLook) return;
  window.__nsCardLook = true;

  var CFG = document.getElementById('NsLook');
  if (!CFG) return;
  var T = {
    add: CFG.getAttribute('data-add') || 'Add to basket',
    view: CFG.getAttribute('data-view') || 'View',
    close: CFG.getAttribute('data-close') || 'Close',
    inCart: CFG.getAttribute('data-in-cart') || 'In basket',
  };
  var SECTION = CFG.getAttribute('data-section-id') || '';
  var SPINNER = CFG.innerHTML;

  /* Room left for the collection above and below the card, and at the sides. */
  var TOP = 52;
  var BOTTOM = 40;
  var SIDE = 20;
  var MAXW = 440; // tablets: a card, not a poster
  var OPEN_MS = 520;
  var CLOSE_MS = 340; // quicker back than out (owner, 1 Oct 2026: impatient scrollers wait too long)
  // One gentle curve both ways (the iOS sheet curve): a soft start, a long settle, no bump at the end.
  var EASE_OPEN = 'cubic-bezier(0.32, 0.72, 0, 1)';
  var EASE_CLOSE = 'cubic-bezier(0.32, 0.72, 0, 1)';
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var root = document.documentElement;

  var layer = null;
  var frame = null;
  var spacer = null;
  var cur = null;
  var busy = false;

  var X_SVG =
    '<svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true" focusable="false">' +
    '<path d="M3.2 3.2l9.6 9.6M12.8 3.2l-9.6 9.6" stroke="currentColor" stroke-width="1.3" fill="none" stroke-linecap="square"/></svg>';

  function build() {
    if (layer) return;
    layer = document.createElement('div');
    layer.className = 'ns-look';
    layer.hidden = true;
    layer.setAttribute('role', 'dialog');
    layer.setAttribute('aria-modal', 'true');
    layer.setAttribute('tabindex', '-1');
    layer.innerHTML =
      '<div class="ns-look__backdrop" data-ns-look-close></div><div class="ns-look__spacer"></div><div class="ns-look__frame product-grid"></div>';
    spacer = layer.children[1];
    frame = layer.children[2];
    document.body.appendChild(layer);
    layer.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-ns-look-close]')) {
        e.preventDefault();
        requestClose();
      }
    });
    frame.addEventListener('click', onFrameClick, true);
    frame.addEventListener('click', photoTap);
  }

  function parse(href) {
    try {
      var u = new URL(href, window.location.href);
      return { path: u.pathname, vid: u.searchParams.get('variant') };
    } catch (e) {
      return null;
    }
  }

  /* ---------- the row under the enlarged card ---------- */

  function actions(c) {
    var block = c.trigger.parentNode; // .ns-card-atc--mobile
    c.block = block;

    var view = document.createElement('a');
    view.className = 'ns-card-atc__btn ns-look-view';
    view.href = c.url;
    view.innerHTML = '<span></span>';
    view.firstChild.textContent = T.view;
    block.appendChild(view);
    c.view = view;

    if (c.mode === 'pick') {
      var holder = document.createElement('div');
      holder.innerHTML =
        '<product-form class="ns-look-form" data-section-id="' + SECTION + '">' +
        '<form method="post" action="' + ((window.routes && window.routes.cart_add_url) || '/cart/add') + '" class="form" novalidate="novalidate" data-type="add-to-cart-form">' +
        '<input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓">' +
        '<input type="hidden" name="id" class="product-variant-id" value="">' +
        '<button type="submit" name="add" class="ns-card-atc__btn" aria-live="polite"><span></span>' + SPINNER + '</button>' +
        '</form></product-form>';
      c.form = holder.firstChild;
      c.form.querySelector('button span').textContent = T.add;
      c.idField = c.form.querySelector('[name="id"]');
      block.appendChild(c.form);
    }

    var x = document.createElement('button');
    x.type = 'button';
    x.className = 'ns-card-atc__btn ns-look-x';
    x.setAttribute('data-ns-look-close', '');
    x.setAttribute('aria-label', T.close);
    x.innerHTML = X_SVG;
    block.appendChild(x);
    c.x = x;

    c.onAdd = function (e) {
      if (e.target.closest && e.target.closest('button.ns-card-atc__btn[form], .ns-look-form button[type="submit"]')) c.adding = Date.now();
    };
    block.addEventListener('click', c.onAdd, true);
  }

  /* What Add adds and where View goes, from what the card shows right now. */
  function sync(c) {
    if (c.mode !== 'pick') return;
    var vid = null;
    var href = null;
    var blocked = false;
    var pill = c.card.querySelector('.ns-card-sizes__pill--quoted');
    if (pill) {
      var p = parse(pill.href);
      if (p) {
        href = pill.href;
        // A size-family pill quoting ANOTHER product (the New Zealand skins):
        // its price is on the card now, so this card's Add would add the
        // wrong thing. View takes the shopper to that product instead.
        if (p.path !== c.path) blocked = true;
        else if (p.vid) vid = p.vid;
      }
    }
    if (!vid && !blocked && c.swatch) {
      var s = parse(c.swatch.href);
      if (s && s.path === c.path && s.vid) {
        vid = s.vid;
        href = c.swatch.href;
      }
    }
    c.view.href = href || c.url;
    var ok = !!vid && !blocked;
    c.block.classList.toggle('ns-look-noadd', !ok);
    if (ok && c.idField.value !== vid) {
      c.idField.value = vid;
      // ns-card-cart-state.js repaints the basket state for the new variant.
      c.idField.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function pickSwatch(c, sw, swapPhoto) {
    var marked = c.card.querySelectorAll('.ns-card-swatch--picked');
    for (var i = 0; i < marked.length; i++) marked[i].classList.remove('ns-card-swatch--picked');
    sw.classList.add('ns-card-swatch--picked');
    c.swatch = sw;
    var src = sw.getAttribute('data-variant-img');
    if (swapPhoto && src && c.main) {
      var img = c.main.img;
      img.removeAttribute('srcset');
      img.setAttribute('src', src);
      // ns-card-variant-swatches.js restores its remembered photo on
      // mouseout, which a tap elsewhere fires: remember the chosen one.
      img.setAttribute('data-ns-orig-src', src);
      img.setAttribute('data-ns-orig-srcset', '');
      if (c.firstSlide) {
        var b0 = bare(src);
        c.firstSlide.srcset = WIDTHS.map(function (x) {
          return sized(b0, x) + ' ' + x + 'w';
        }).join(', ');
        c.firstSlide.src = sized(b0, 1080);
      }
      if (c.gallery) c.gallery.scrollTo({ left: 0, behavior: 'smooth' });
    }
    sync(c);
  }

  function preselect(c) {
    var sws = c.card.querySelectorAll('[data-ns-swatch]');
    if (!sws.length || !c.defaultVid) return;
    for (var i = 0; i < sws.length; i++) {
      var p = parse(sws[i].href);
      if (p && p.vid === c.defaultVid) {
        pickSwatch(c, sws[i], false);
        return;
      }
    }
  }

  function onFrameClick(e) {
    var c = cur;
    if (!c || c.mode !== 'pick') return;
    var sw = e.target.closest && e.target.closest('[data-ns-swatch]');
    if (sw) {
      // A real tap (detail > 0): the first one chooses the colour, a second
      // tap on the same one opens it. Keyboard Enter goes straight through.
      if (e.detail && c.swatch !== sw) {
        e.preventDefault();
        pickSwatch(c, sw, true);
      }
      return;
    }
    // ns-variant-price.js has already moved the quote (document, capture).
    if (e.target.closest && e.target.closest('.ns-card-sizes__pill')) sync(c);
  }

  /* ---------- the photos ----------
     SHARP (owner, 1 Oct 2026: "the enlarged images seem to be slightly
     blurry"). The card's own picture was chosen for a card half the width: at
     twice the size it showed a 533px file on a 1000px-wide iPhone photo, and
     Safari does not reliably fetch a bigger one when `sizes` changes. So the
     enlarged card gets its own copy of the same photo, asked for at its real
     size, laid over the card's picture once it is fully decoded, so it can
     only ever sharpen, never flash. (A photo whose original is small stays
     soft: the file itself is the limit.)
     SWIPEABLE ("for products with multiple images can you also make it so you
     can swipe to see the other images on the enlarged card? like the product
     page scroll behaviour"). The product's other photos are asked for only
     when a card is opened (the product's own .js, cached by the browser), so
     the collection page carries none of them, and join the sharp one as
     slides, with dots when there is more than one. */
  var photoLists = Object.create(null);
  var WIDTHS = [540, 720, 1080, 1440, 2100];

  function fileOf(u) {
    return String(u || '').split('?')[0].split('/').pop();
  }
  function bare(u) {
    // the address without Shopify's width= (and without a trailing ? or &)
    return String(u || '').replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
  }
  function sized(src, w) {
    var s = src.indexOf('//') === 0 ? 'https:' + src : src;
    return s + (s.indexOf('?') < 0 ? '?' : '&') + 'width=' + w;
  }
  /* sizes, then srcset, then src (audit, 2 Oct 2026): an image starts loading
     the moment it has a src, so with src first every iPhone fetched the photo
     twice, the 1080 for src and then the 1440 that srcset picked against the
     default sizes of the whole screen (measured in WebKit on every card). */
  function sharp(src, alt, w) {
    var im = document.createElement('img');
    im.alt = alt || '';
    im.decoding = 'async';
    im.sizes = w + 'px';
    im.srcset = WIDTHS.map(function (x) {
      return sized(src, x) + ' ' + x + 'w';
    }).join(', ');
    im.src = sized(src, 1080);
    return im;
  }

  function slide(c, im) {
    var s = document.createElement('div');
    s.className = 'ns-look-gallery__slide';
    im.style.objectFit = c.fitMode;
    s.appendChild(im);
    return s;
  }

  // The sharp copy of what the card shows: the gallery's first slide.
  /* SHARP WHILE IT GROWS (owner, 1 Oct 2026: "the product image itself when
     you zoom in jumps a bit at the end like it sharpens ... maybe this can
     also happen fluent the moment it zooms in?"). The sharp copy is asked for
     the moment a finger touches "A closer look" (pointerdown, before the tap
     even completes: every enlarged card has the same width, so its size is
     known in advance), and it fades in as soon as it is decoded, usually while
     the card is still growing, so the sharpening melts into the zoom instead
     of arriving after it. It lies exactly over the card's own picture (same
     place, same fit), so the fade changes sharpness only. */
  var pre = null; // { card, img } started on pointerdown

  function finalWidth() {
    return Math.min(root.clientWidth - 2 * SIDE, MAXW);
  }

  function sharpFor(card) {
    var main = card.querySelector('.card__media img');
    if (!main) return null;
    var src = bare(main.currentSrc || main.getAttribute('src'));
    if (!src) return null;
    var im = sharp(src, main.alt, finalWidth());
    if (im.decode) im.decode().catch(function () {});
    return im;
  }

  function prepare(trigger) {
    var card = trigger.closest('.card-wrapper');
    if (!card || (pre && pre.card === card)) return;
    var im = sharpFor(card);
    pre = im ? { card: card, img: im } : null;
  }

  function hires(c) {
    var media = c.card.querySelector('.card__media');
    if (!media || !c.main) return;
    var first = pre && pre.card === c.card ? pre.img : sharpFor(c.card);
    pre = null;
    if (!first) return;
    c.fitMode = c.fitMode || window.getComputedStyle(c.main.img).objectFit || 'cover';
    var g = document.createElement('div');
    g.className = 'ns-look-gallery';
    g.appendChild(slide(c, first));
    c.firstSlide = first;
    var up = function () {
      if (cur !== c || c.closing || c.gallery) return;
      c.galleryReady = g;
      showGallery(c);
    };
    /* Only a photo that decoded is laid over the card's own (audit, 2 Oct 2026:
       a failed one used to cover it as a broken image). A decode can also be
       refused for a photo that did arrive; then what arrived decides. */
    (first.decode ? first.decode() : Promise.resolve()).then(up, function () {
      if (first.complete && first.naturalWidth) up();
    });
  }

  /* Laid over the card's own picture with a fade: slower while the card is
     still growing, so the change hides in the motion. */
  function showGallery(c) {
    var g = c.galleryReady;
    var media = c.card.querySelector('.card__media');
    if (!g || c.gallery || !media || cur !== c || c.closing) return;
    g.style.opacity = '0';
    media.appendChild(g);
    c.card.classList.add('ns-look-has-gallery');
    c.gallery = g;
    g.getBoundingClientRect();
    g.style.transition = 'opacity ' + (busy ? 360 : 220) + 'ms ease';
    g.style.opacity = '1';
    if (c.pendingPhotos) more(c, c.pendingPhotos);
  }

  // The dots come once the card has settled (they would only flicker in motion).
  function showDots(c) {
    var dots = c.dotsReady;
    var inner = c.card.querySelector('.card__inner');
    if (!dots || c.dots || !inner || busy || cur !== c || c.closing) return;
    dots.style.opacity = '0';
    inner.appendChild(dots);
    dots.getBoundingClientRect();
    dots.style.transition = 'opacity 220ms ease';
    dots.style.opacity = '1';
    c.dots = dots;
  }

  function photos(c) {
    if (!c.path) return;
    var key = c.path;
    var got = photoLists[key]
      ? Promise.resolve(photoLists[key])
      : fetch(key.replace(/\/$/, '') + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) {
            return r.ok ? r.json() : null;
          })
          .then(function (p) {
            var list = [];
            ((p && p.media) || []).forEach(function (m) {
              if (m.media_type === 'image' && m.src) list.push({ src: m.src, alt: m.alt || '' });
            });
            photoLists[key] = list;
            return list;
          });
    got
      .then(function (list) {
        if (cur !== c || c.closing || !list) return;
        if (c.gallery) more(c, list);
        else c.pendingPhotos = list; // added as soon as the sharp first photo is up
      })
      .catch(function () {});
  }

  // The product's other photos, as slides after the first, and the dots.
  function more(c, list) {
    if (!c.gallery || c.dots || c.dotsReady || !c.main) return;
    var shown = fileOf(c.main.img.currentSrc || c.main.img.getAttribute('src'));
    var rest = list.filter(function (m) {
      return fileOf(m.src) !== shown;
    });
    if (!rest.length) return; // one photo: nothing to swipe
    var g = c.gallery;
    var w = frame.offsetWidth || 400;
    rest.forEach(function (m, i) {
      var im = sharp(m.src, m.alt, w);
      if (i > 0) im.loading = 'lazy'; // the second photo is ready before the first swipe
      var s = slide(c, im);
      // A photo that fails leaves the strip, and its dot with it.
      im.addEventListener('error', function () {
        var k = Array.prototype.indexOf.call(g.children, s);
        if (k < 1) return;
        s.remove();
        var d = c.dotsReady && c.dotsReady.children[k];
        if (d) d.remove();
        if (g.children.length < 2) {
          g.classList.remove('is-multi');
          if (c.dotsReady) c.dotsReady.style.display = 'none';
        }
      });
      g.appendChild(s);
    });
    g.classList.add('is-multi'); // only now a swipeable strip
    var dots = document.createElement('div');
    dots.className = 'ns-look-dots';
    dots.setAttribute('aria-hidden', 'true');
    for (var i = 0; i < g.children.length; i++) {
      var d = document.createElement('span');
      if (!i) d.className = 'is-on';
      dots.appendChild(d);
    }
    var on = 0;
    g.addEventListener(
      'scroll',
      function () {
        var k = Math.round(g.scrollLeft / Math.max(1, g.clientWidth));
        if (k === on || !dots.children[k]) return;
        dots.children[on].classList.remove('is-on');
        dots.children[k].classList.add('is-on');
        on = k;
      },
      { passive: true }
    );
    c.dotsReady = dots;
    showDots(c);
  }

  /* ---------- a tap on the photo opens the product page ----------
     Owner, 1 Oct 2026: "can you remove the zoom function they will just have
     to go to the product page for this and then if they tab again it just
     goes to the product page instead? it just has to notice the difference
     between tab to go and between swipe to look at other images if other
     images are available". The same page as View, the same way (its link, so
     the way back is the same too). A swipe through the photos never turns
     into a click: the browser takes the finger over for its own scroll and
     cancels the pointer, so a click here is a tap. Not while the card is
     still moving, and never from the heart or anything else that is a
     control (they keep their own jobs). */
  function photoTap(e) {
    var c = cur;
    if (!c || c.closing || busy || e.defaultPrevented || !c.view) return;
    var t = e.target;
    if (!t.closest || !t.closest('.card__inner') || t.closest('button, a, input, label, select, [role="button"]')) return;
    e.preventDefault();
    c.view.click();
  }

  /* ---------- "In basket", for a moment ----------
     After an add that does not open the basket drawer, the theme confirms on a
     phone by bringing the floating header down with the basket count (owner,
     20 Sep 2026), which here plays under the dimmed collection. So the Add
     button itself says "✓ In basket" for a moment; a hide that is now all in
     the basket then simply keeps saying so. */
  function flashAdded(c) {
    var btn = c.form ? c.form.querySelector('button[type="submit"]') : c.block && c.block.querySelector(':scope > button.ns-card-atc__btn[form]');
    if (!btn) return;
    btn.setAttribute('data-ns-added', '✓ ' + T.inCart);
    btn.classList.add('ns-look-added');
    window.clearTimeout(btn.__nsAddedT);
    btn.__nsAddedT = window.setTimeout(function () {
      btn.classList.remove('ns-look-added');
    }, 1700);
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (e) {
      var c = cur;
      if (!c || c.closing || !c.adding || Date.now() - c.adding > 10000) return;
      if (e && e.source && e.source !== 'product-form') return;
      c.adding = 0;
      flashAdded(c);
    });
  }

  /* ---------- size and place ---------- */

  /* Only the card that moved (audit, 2 Oct 2026): re-fitting every size row on
     the page at each open and close was most of the open's forced layout on a
     slow phone (about 0.8 s at 4x CPU). */
  function fitPills(el) {
    if (typeof window.nsFitSizePills === 'function') window.nsFitSizePills(el);
  }

  function place(g) {
    frame.style.left = g.left + 'px';
    frame.style.top = g.top + 'px';
    frame.style.width = g.width + 'px';
  }

  function ratio(v) {
    if (v) frame.style.setProperty('--ns-look-ratio', v);
    else frame.style.removeProperty('--ns-look-ratio');
  }

  /* ONE SIZE FOR EVERY CARD (owner, 1 Oct 2026: "some cards are smaller then
     others can you make sure the images are always big and that the content
     layout just switches size a bit to support it"). Every enlarged card is
     the full width; a card with more to say (sizes, colours) used to be made
     narrower to fit the screen. Now, where photo and words would not fit:
       1. the words close up (.ns-look-compact: smaller gaps, same sizes);
       2. the room above and below the card shrinks;
       3. the photo BOX gives way last, and never at the photo's expense: a
          photo that sits inside its box (a square hide) loses only the empty
          margin around it; a photo that fills its box loses at most a tenth,
          half at the top and half at the bottom. (Squaring every box, the
          first try, cut the top and bottom off a New Zealand skin.)
     What still does not fit scrolls, on the smallest phones only. */
  var ROOM = [[TOP, BOTTOM], [30, 24], [20, 16]];
  function fit(c) {
    var vw = root.clientWidth;
    var vh = window.innerHeight;
    var w = Math.min(vw - 2 * SIDE, MAXW);
    frame.style.width = w + 'px';
    frame.classList.remove('ns-look-compact');
    ratio('');
    fitPills(frame);
    var inner = c.card.querySelector('.card__inner');
    var ph = inner ? inner.offsetHeight : 0;
    var h = frame.offsetHeight;
    if (h > vh - ROOM[0][0] - ROOM[0][1]) {
      frame.classList.add('ns-look-compact');
      h = frame.offsetHeight;
      ph = inner ? inner.offsetHeight : 0;
    }
    var k = 0;
    while (k < ROOM.length - 1 && h > vh - ROOM[k][0] - ROOM[k][1]) k++;
    var top0 = ROOM[k][0];
    var bottom0 = ROOM[k][1];
    var avail = vh - top0 - bottom0;
    if (h > avail && ph) {
      var own = ph / w;
      var floor = c.fitMode === 'contain' ? Math.min(own, c.minRatio || own) : own * 0.9;
      ratio((Math.max(own - (h - avail) / w, floor) * 100).toFixed(3) + '%');
      h = frame.offsetHeight;
    }
    var top = h <= avail ? top0 + Math.round((avail - h) / 2) : top0;
    c.tall = h > avail;
    c.final = { left: Math.round((vw - w) / 2), top: top, width: w, height: h, ratio: frame.style.getPropertyValue('--ns-look-ratio') };
    place(c.final);
    spacer.style.height = top + h + bottom0 + 'px';
    c.vw = vw;
    equalise(c);
  }

  /* THE BUTTONS STAY ON SCREEN (audit, 2 Oct 2026). With Safari's bars showing,
     a card with sizes and colours is taller than the screen on most iPhones
     (Mouflon: 649px against the 553px an iPhone SE shows, 673px against an
     iPhone 12-15's 664px), and View · Add to basket · x sat below the screen
     or half cut. Cropping the photo further would be the square crop already
     turned down for the New Zealand skin, so the card keeps its photo and
     scrolls, and its button row stays pinned to the bottom of the screen until
     the card's own end reaches it (.ns-look-pin, northsheep-collection.css).
     Only once the card has arrived, and off before it goes back, so the
     motion itself is untouched. */
  function pin(c) {
    frame.classList.toggle('ns-look-pin', !!(c && c.tall && cur === c && !c.closing && !busy));
  }

  /* View and Add the same width (owner, 30 Sep 2026: "can you make the view
     and add to basket same size?"). Where a label would be cut off at half
     the row (the longest translations on the narrowest cards), View goes
     back to its own width instead: a whole word beats a matched pair. */
  function equalise(c) {
    var blk = c.block;
    if (!blk) return;
    blk.classList.remove('ns-look-unequal');
    var labels = blk.querySelectorAll(':scope > .ns-look-view > span, :scope > button.ns-card-atc__btn[form] > span, :scope > .ns-look-form button > span');
    for (var i = 0; i < labels.length; i++) {
      if (labels[i].scrollWidth > labels[i].clientWidth + 1) {
        blk.classList.add('ns-look-unequal');
        return;
      }
    }
  }

  /* ---------- the motion ----------
     The card RESIZES; it is not zoomed (owner, 1 Oct 2026: "the content inside
     the cart just disappears and appears again but can you not make the
     content just stretch and shrink fluently as well with the cards?"). Its
     place, width, photo box and button row grow from its exact place in the
     grid to the middle of the screen, and the browser lays it out afresh at
     every step: the photo grows, the title and the price keep their size and
     simply re-wrap, the heart and the badges stay the size they are. Nothing
     fades and nothing is scaled, so nothing can blink, pop or blur, and on the
     way back it ends at exactly the grid card's width, photo shape and height:
     the hand-over to the grid is the same card, in the same place.
     (Earlier rounds zoomed a picture of the card, then flew the real card with
     a card-shaped box behind it and faded its words; each left a seam.)
     The one thing that changes is the button row: "A closer look" while the
     card moves, View · Add to basket · x once it is open (a short cross-fade,
     .ns-look-rowgrid). The heights and gaps of the open card (.ns-look-big)
     and the photo box shape (--ns-look-ratio) move with the same timing
     (--ns-look-dur / --ns-look-ease in northsheep-collection.css). */
  function motion(ms, ease, shadow) {
    frame.style.setProperty('--ns-look-dur', ms + 'ms');
    frame.style.setProperty('--ns-look-ease', ease || 'ease');
    frame.style.transition = ms ? 'box-shadow ' + (shadow || ms + 'ms ' + ease) : 'none';
  }

  /* THE CARD'S PLACE AND SIZE, FRAME BY FRAME. Left, top, width and height are
     set by this script on every frame, on the same curve the CSS parts use
     (photo box, buttons, heart): so the way back can aim at where the card's
     place in the grid IS on that frame, not where it was when x was tapped.
     Owner, 1 Oct 2026: "if i scroll a bit further down the collection the card
     doesnt fit perfectly anymore when it closes" - anything that moved the
     grid meanwhile (a promo picture loading above, the page settling, a
     scroll) left the card aiming at an old spot, and it jumped at the end.
     Now it glides into its place wherever that goes, and it ends exactly when
     its curve ends, with no browser hand-over in between. */
  function bezier(x1, y1, x2, y2) {
    function a(p1, p2) { return 1 - 3 * p2 + 3 * p1; }
    function b(p1, p2) { return 3 * p2 - 6 * p1; }
    function at(t, p1, p2) { return ((a(p1, p2) * t + b(p1, p2)) * t + 3 * p1) * t; }
    return function (x) {
      if (x <= 0) return 0;
      if (x >= 1) return 1;
      var lo = 0;
      var hi = 1;
      var t = x;
      for (var i = 0; i < 24; i++) {
        var v = at(t, x1, x2);
        if (Math.abs(v - x) < 1e-5) break;
        if (v < x) lo = t;
        else hi = t;
        t = (lo + hi) / 2;
      }
      return at(t, y1, y2);
    };
  }
  var CURVE = bezier(0.32, 0.72, 0, 1); // = EASE_OPEN / EASE_CLOSE
  var tweenId = 0;

  /* ONE HEIGHT, ONE CURVE (owner, 1 Oct 2026: "it still closes to regular card
     size and then it shows a 2nd animation that it stretch to extended length
     card ... i want one fluent"). The card is as tall as its words need or as
     the height it is given, whichever is more. The given height used to start
     from nothing on the way back, so the words shrank the card to its own
     length first and the row's length took over after: two motions. Now the
     given height runs from the height the card HAS to the height it will have
     (its row's, next to a longer card), so it leads all the way and the card
     moves once. A little extra in the middle of the move (ARC, never at either
     end) keeps a title that re-wraps along the way from nudging the edge. */
  var ARC = 24;

  function geom() {
    return {
      left: parseFloat(frame.style.left) || 0,
      top: parseFloat(frame.style.top) || 0,
      width: parseFloat(frame.style.width) || frame.offsetWidth,
      minH: parseFloat(frame.style.minHeight) || 0,
    };
  }

  function tween(ms, from, to, end) {
    var id = ++tweenId;
    var t0 = 0;
    function step(now) {
      if (id !== tweenId) return; // a newer move took over (closed while opening)
      if (!t0) t0 = now;
      var k = Math.min(1, (now - t0) / ms);
      var e = CURVE(k);
      var g = typeof to === 'function' ? to() : to;
      frame.style.left = from.left + (g.left - from.left) * e + 'px';
      frame.style.top = from.top + (g.top - from.top) * e + 'px';
      frame.style.width = from.width + (g.width - from.width) * e + 'px';
      var span = g.minH - from.minH;
      var arc = Math.min(ARC, Math.abs(span) / 4); // /4: the arc never turns the height back on itself
      frame.style.minHeight = from.minH + span * e + arc * 4 * e * (1 - e) + 'px';
      if (k < 1) window.requestAnimationFrame(step);
      else if (end) end();
    }
    step(performance.now());
  }

  function remove(el) {
    if (el && el.parentNode) el.parentNode.removeChild(el);
  }

  // The card's own photo shape in the grid (Dawn's --ratio-percent).
  function gridRatio(card) {
    var inner = card.querySelector('.card__inner');
    return inner ? inner.style.getPropertyValue('--ratio-percent').trim() : '';
  }

  /* ---------- open / close ---------- */

  /* The card's stylesheet loads without holding the first paint (theme.liquid,
     audit 4 Oct 2026, O5). Until it has arrived a tap waits for it, so the
     card never opens unstyled; the load also switches it on here, in case the
     link's own onload did not run. */
  var styleWait = null;
  function whenStyled(go) {
    var l = document.getElementById('ns-card-look-css');
    if (!l || l.media === 'all') return true;
    if (l.sheet) {
      l.media = 'all';
      return true;
    }
    if (!styleWait) {
      styleWait = go;
      var done = function () {
        l.removeEventListener('load', done);
        l.removeEventListener('error', done);
        l.media = 'all';
        var g = styleWait;
        styleWait = null;
        if (g) g();
      };
      // A failed download opens the card as a blocking sheet's failure did.
      l.addEventListener('load', done);
      l.addEventListener('error', done);
    } else {
      styleWait = go;
    }
    return false;
  }

  function open(trigger, kbd) {
    if (!whenStyled(function () { open(trigger, kbd); })) return;
    // Opening the next card while the last one is still on its way back: that
    // one lands at once, so nobody waits to look at the next product.
    if (cur && cur.closing && cur.finish) cur.finish();
    if (busy || cur) return;
    var card = trigger.closest('.card-wrapper');
    var slot = card && card.parentNode;
    if (!slot) return;
    build();
    busy = true;

    var link = card.querySelector('.card__heading a, a.full-unstyled-link');
    var url = link ? link.href : '';
    var c = (cur = {
      trigger: trigger,
      kbd: !!kbd,
      card: card,
      slot: slot,
      next: card.nextSibling,
      mode: trigger.getAttribute('data-ns-look') || 'view',
      url: url,
      path: url ? (parse(url) || {}).path : '',
      defaultVid: trigger.getAttribute('data-vid') || '',
      imgs: [],
      swatch: null,
      gridRatio: gridRatio(card),
    });
    var imgs = card.querySelectorAll('.card__media img');
    for (var i = 0; i < imgs.length; i++) c.imgs.push([imgs[i], imgs[i].getAttribute('sizes')]);
    if (imgs[0]) {
      c.main = { img: imgs[0] };
      c.fitMode = window.getComputedStyle(imgs[0]).objectFit || 'cover';
      c.minRatio = c.fitMode === 'contain' && imgs[0].naturalWidth ? imgs[0].naturalHeight / imgs[0].naturalWidth : 1;
    }

    // FIRST: the card's exact place and shape. Its grid place keeps its height.
    // Where the card is SEEN: the theme lifts a tapped card 6px and 1.5%, so
    // starting from its box made it drop at the first frame.
    var shown = card.querySelector('.card') || card;
    var first = shown.getBoundingClientRect();
    var slotH = slot.getBoundingClientRect().height;
    slot.style.minHeight = slotH + 'px';
    slot.classList.add('ns-look-slot');

    var title = card.querySelector('.card__heading');
    layer.setAttribute('aria-label', title ? title.textContent.trim() : '');
    root.classList.add('ns-look-open', 'ns-look-lock');
    layer.hidden = false;
    layer.scrollTop = 0;
    motion(0);
    frame.classList.add('ns-look-big', 'ns-look-rowgrid');
    frame.appendChild(card);
    actions(c);
    if (c.mode === 'pick') {
      preselect(c);
      sync(c);
    }

    // LAST: its size in the middle of the screen, measured in its open state.
    fit(c);
    hires(c);
    photos(c);
    if (reduce) {
      frame.classList.remove('ns-look-rowgrid');
      layer.classList.add('is-open');
      busy = false;
      pin(c);
    } else {
      var fin = c.final;
      // Back to the start: the grid card, exactly (width, photo shape, height, buttons).
      frame.classList.remove('ns-look-big');
      ratio(c.gridRatio);
      frame.style.minHeight = first.height + 'px';
      place({ left: first.left, top: first.top + layer.scrollTop, width: first.width });
      frame.getBoundingClientRect(); // commit the start before animating
      window.requestAnimationFrame(function () {
        motion(OPEN_MS, EASE_OPEN);
        frame.classList.add('ns-look-big');
        ratio(fin.ratio);
        layer.classList.add('is-open');
        // View · Add to basket · x come in over the last stretch of the growth,
        // when the card is already wide enough for them (owner, 1 Oct 2026:
        // "can you even make the view/add to basket/ x appear more smooth?").
        window.setTimeout(function () {
          if (cur === c && !c.closing) frame.classList.remove('ns-look-rowgrid');
        }, Math.round(OPEN_MS * 0.5));
        tween(OPEN_MS, geom(), { left: fin.left, top: fin.top, width: fin.width, minH: fin.height }, function () {
          if (cur !== c || c.closing) return;
          frame.style.minHeight = ''; // its words' own height, which is where it arrived
          frame.classList.remove('ns-look-rowgrid'); // View · Add to basket · x
          busy = false;
          pin(c);
          showGallery(c);
          showDots(c);
        });
      });
    }

    // One history entry, so the phone's back gesture closes the card
    // instead of leaving the collection. searchParams is Dawn's own key
    // (facets.js): with it, Dawn sees nothing to re-filter on the way back.
    try {
      var st = Object.assign({}, window.history.state || {});
      st.nsLook = true;
      if (st.searchParams === undefined) {
        st.searchParams =
          typeof FacetFiltersForm !== 'undefined' && FacetFiltersForm.searchParamsPrev != null
            ? FacetFiltersForm.searchParamsPrev
            : window.location.search.slice(1);
      }
      window.history.pushState(st, '');
      c.pushed = true;
    } catch (e) {}

    // Focus into the dialog. From a keyboard onto x, so Escape or Enter is one
    // key away; from a tap onto the dialog itself, so no focus ring appears
    // on a button nobody pressed (WebKit drew one).
    try {
      (c.kbd ? c.x : layer).focus({ preventScroll: true });
    } catch (e) {}
  }

  /* Back to the grid card. The photo is left exactly as it is: its larger
     `sizes` stays (a smaller one could make the browser fetch and swap the
     picture just as the card lands), and so does a colour chosen in the large
     view (ns-card-variant-swatches.js keeps showing it too). */
  function teardown(c) {
    [c.view, c.form, c.x].forEach(remove);
    if (c.block && c.onAdd) c.block.removeEventListener('click', c.onAdd, true);
    if (c.block) c.block.classList.remove('ns-look-noadd', 'ns-look-unequal');
    var marked = c.card.querySelectorAll('.ns-card-swatch--picked');
    for (var i = 0; i < marked.length; i++) marked[i].classList.remove('ns-card-swatch--picked');
  }

  function close(instant) {
    var c = cur;
    if (!c || c.closing) return;
    c.closing = true;
    busy = true;
    frame.classList.remove('ns-look-pin'); // the row back in its place before the card moves
    var animate = !instant && !reduce;
    var dur = CLOSE_MS;
    var to = c.slot.getBoundingClientRect();
    if (c.dots) {
      c.dots.style.transition = 'opacity ' + Math.min(150, dur / 2) + 'ms ease';
      c.dots.style.opacity = '0';
    }
    // The sharp layer (or a swiped-to photo) gives way to the card's own
    // picture, which lies beneath it, as the card starts back.
    if (c.gallery) {
      c.gallery.style.transition = 'opacity ' + Math.min(200, dur) + 'ms ease';
      c.gallery.style.opacity = '0';
    }
    layer.classList.remove('is-open'); // the dimmed collection clears
    // THE PAGE IS FREE AT ONCE (owner, 1 Oct 2026: "i try scrolling sometimes and
    // then instead i accidently select the page instead of scrolling as the
    // window was not fully closed yet"): scrolling unlocks the moment close is
    // tapped, and the card on its way back no longer catches touches, which
    // now go straight to the collection.
    root.classList.remove('ns-look-lock');
    layer.classList.add('is-closing');
    var landed = false;
    function done() {
      if (landed) return;
      landed = true;
      tweenId++; // stop any move still running
      // Home: the same card, the same photo, the same shape it already has.
      c.slot.insertBefore(c.card, c.next && c.next.parentNode === c.slot ? c.next : null);
      teardown(c);
      remove(c.gallery);
      remove(c.dots);
      c.card.classList.remove('ns-look-has-gallery');
      c.gallery = c.dots = c.firstSlide = c.pendingPhotos = c.galleryReady = c.dotsReady = null;
      motion(0);
      frame.classList.remove('ns-look-big', 'ns-look-rowgrid', 'ns-look-compact', 'ns-look-pin');
      ratio('');
      frame.style.minHeight = '';
      frame.style.transform = '';
      frame.style.width = '';
      frame.style.left = '';
      frame.style.top = '';
      layer.hidden = true;
      layer.classList.remove('is-closing');
      root.classList.remove('ns-look-open', 'ns-look-lock');
      c.slot.style.minHeight = '';
      c.slot.classList.remove('ns-look-slot');
      fitPills(c.card);
      // Back to the card's button only for keyboard use (where the focus
      // has to go somewhere sensible); after a tap it would only draw a
      // focus ring round "A closer look" (measured in WebKit).
      try {
        if (c.kbd) c.trigger.focus({ preventScroll: true });
        else if (document.activeElement && layer.contains(document.activeElement)) document.activeElement.blur();
      } catch (e) {}
      cur = null;
      busy = false;
    }

    c.finish = done;
    if (!animate) {
      done();
      return;
    }
    var from = geom();
    from.minH = frame.offsetHeight; // the height it has now, read before anything changes (see ARC)
    // The shadow leaves at once, not on the card's long settle: a faint edge of
    // it was still showing as the card landed (owner, 1 Oct 2026).
    motion(dur, EASE_CLOSE, Math.min(180, dur - 60) + 'ms ease-out');
    frame.classList.add('ns-look-rowgrid'); // "A closer look" back first
    frame.classList.remove('ns-look-big');
    ratio(c.gridRatio);
    tween(
      dur,
      from,
      function () {
        // Where its place is NOW, on this frame (scrolled, or moved by
        // something that loaded above it), and how tall its grid row is.
        var r = c.slot.getBoundingClientRect();
        return { left: r.left, top: r.top + layer.scrollTop, width: r.width, minH: r.height };
      },
      done
    );
  }

  /* x, the dimmed collection, Escape: the card starts back at once, and the
     history entry it added is taken back in the same moment (the popstate
     that follows finds it already closing and leaves it alone). Waiting for
     that popstate first cost a visible beat before anything moved. */
  function requestClose() {
    var c = cur;
    if (!c || c.closing) return;
    var pop = c.pushed && window.history.state && window.history.state.nsLook;
    close();
    if (pop) window.history.back();
  }

  window.addEventListener('popstate', function (e) {
    // Still on the card's own entry: nothing moved (an older WebKit fires a
    // popstate for it as the page comes back from the back-forward cache;
    // pageshow below takes care of that return).
    if (e.state && e.state.nsLook) return;
    if (cur && !cur.closing) {
      cur.pushed = false;
      close();
    }
  });

  /* BACK FROM THE PRODUCT PAGE: THE CARD COMES BACK, THEN GOES HOME (owner,
     1 Oct 2026: "instead of trying to close it first just close it on the
     back. so click view go product page directly, click back load on the card
     but the card closes directly. so people can continue scrolling").
     View (and the title, a colour's second tap) are plain links: the product
     page opens at once and the card stays as it is. What two tries showed:
       - the phone shows its picture of the page as it was left on the way
         Back (WebKit takes it when the next page arrives: WebBackForwardList::
         addItem -> recordAutomaticNavigationSnapshot; a swipe keeps it up
         until the real page has drawn, loaded and restored its scroll:
         ViewGestureController), so closing the card as the page was left
         showed the open card first and then a closed one;
       - closing it BEFORE leaving lost the race on the owner's phone (the
         product page was there before the card was home: a half-closed card
         in the picture).
     So the picture shows the open card, the page comes back the same, and
     the card then goes home on its usual close, with its history entry, as
     with x. It waits until the collection behind it has its place back (the
     back-forward cache can hand the page back at the top: ns-grid-restore.js
     puts it right), or it would fly at where its place was a moment ago. */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    var c = cur;
    if (c && !c.closing) {
      settled(function () {
        if (cur === c && !c.closing) requestClose();
      });
      return;
    }
    // Back on the card's entry with nothing open (left while it was closing):
    // step off it on the same page, so the next Back leaves at once.
    try {
      if (!c && window.history.state && window.history.state.nsLook) window.history.back();
    } catch (err) {}
  });

  // The page has stopped moving: the same scroll position on three looks in a
  // row (50ms apart), at least 120ms in, at most 700ms. Timers, not frames: a
  // page coming back may not be drawn yet.
  function settled(fn) {
    var t0 = Date.now();
    var last = -1;
    var same = 0;
    (function look() {
      var y = Math.round(window.pageYOffset || 0);
      same = y === last ? same + 1 : 0;
      last = y;
      if ((same >= 2 && Date.now() - t0 >= 120) || Date.now() - t0 > 700) fn();
      else window.setTimeout(look, 50);
    })();
  }

  // Left while the card was on its way back: it lands at once, so the page is
  // not kept with a card half way.
  window.addEventListener('pagehide', function () {
    var c = cur;
    if (c && c.closing && c.finish) c.finish();
  });

  // A reload keeps the history entry but not the open card: drop the mark,
  // so the next Back leaves as it normally would.
  try {
    if (window.history.state && window.history.state.nsLook) {
      var st = Object.assign({}, window.history.state);
      delete st.nsLook;
      window.history.replaceState(st, '');
    }
  } catch (e) {}

  /* The card's quick view button, or the price right above it, which opens it
     too (owner, 1 Oct 2026: "if people click quick view or accidently above
     near price they see the quick view"; the price is lifted over the card's
     link and given the gap to the button in northsheep-collection.css). Only
     where the button shows: phones, the grid, not the one-column view. */
  function triggerOf(node) {
    if (!node || !node.closest) return null;
    var t = node.closest('[data-ns-look]');
    if (t) return t;
    /* Not with calm cards (owner, 4 Oct 2026: "price tap should open the
       product page"): there the price is the card's last line, far from
       Enlarge, which sits under the photo. It goes back under the card's
       link, like the name (ns-card-calm.css). */
    if (document.body.classList.contains('ns-calmcard')) return null;
    var p = node.closest('#product-grid .card-information > .price');
    var b = p && p.parentNode.querySelector(':scope > .ns-card-atc--mobile > .ns-card-look');
    return b && b.offsetParent !== null ? b : null;
  }

  document.addEventListener(
    'pointerdown',
    function (e) {
      var t = triggerOf(e.target);
      if (t && !cur) prepare(t);
    },
    { passive: true }
  );

  document.addEventListener('click', function (e) {
    var t = triggerOf(e.target);
    if (!t) return;
    e.preventDefault();
    open(t, e.detail === 0); // detail 0: Enter or Space, not a tap
  });

  /* A FINGER ON THE PRICE. The touch lands on the price, but the price is not
     a link, so the browser hands the click it makes to the nearest thing that
     is one: the card's title link, which covers the whole card underneath
     ("touch adjustment"; measured in WebKit: touchstart/touchend on the price,
     click on the link -> product page). So a short, still tap on the price
     opens the quick view at touchend and cancels that click; a swipe or a
     long press is left alone. */
  var tapOn = null;
  var swallow = 0;
  document.addEventListener(
    'touchstart',
    function (e) {
      tapOn = null;
      if (cur || e.touches.length !== 1) return;
      var p = e.target.closest && e.target.closest('#product-grid .card-information > .price');
      var t = p && triggerOf(p);
      if (t) tapOn = { t: t, x: e.touches[0].clientX, y: e.touches[0].clientY, at: Date.now() };
    },
    { passive: true }
  );
  document.addEventListener(
    'touchmove',
    function (e) {
      if (tapOn && Math.abs(e.touches[0].clientX - tapOn.x) + Math.abs(e.touches[0].clientY - tapOn.y) > 10) tapOn = null;
    },
    { passive: true }
  );
  document.addEventListener(
    'touchend',
    function (e) {
      var s = tapOn;
      tapOn = null;
      if (!s || cur || Date.now() - s.at > 600) return;
      e.preventDefault(); // no click: it would open the product page
      swallow = Date.now() + 400; // in case a browser makes one anyway (it comes at once)
      open(s.t, false);
    },
    { passive: false }
  );
  document.addEventListener(
    'touchcancel',
    function () {
      tapOn = null;
    },
    { passive: true }
  );
  window.addEventListener(
    'click',
    function (e) {
      if (!swallow) return;
      var late = Date.now() > swallow;
      swallow = 0;
      if (late) return;
      e.preventDefault();
      e.stopPropagation();
    },
    true
  );

  document.addEventListener('keydown', function (e) {
    if (!cur) return;
    // The basket drawer opened from the card sits on top and handles its own
    // keys: Escape closes the drawer only, and the card stays open under it.
    if (document.querySelector('cart-drawer.active')) return;
    if (e.key === 'Escape') {
      e.preventDefault();
      cur.kbd = true;
      requestClose();
      return;
    }
    if (e.key !== 'Tab') return;
    var list = frame.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]), [tabindex]:not([tabindex="-1"])');
    var f = [];
    for (var i = 0; i < list.length; i++) if (list[i].offsetParent !== null) f.push(list[i]);
    if (!f.length) return;
    var a = document.activeElement;
    if (!frame.contains(a)) {
      e.preventDefault();
      f[0].focus();
    } else if (e.shiftKey && a === f[0]) {
      e.preventDefault();
      f[f.length - 1].focus();
    } else if (!e.shiftKey && a === f[f.length - 1]) {
      e.preventDefault();
      f[0].focus();
    }
  });

  // A turned phone gets a new fit; a height-only change (the iPhone toolbar
  // showing or hiding) leaves the card exactly where it is.
  window.addEventListener('resize', function () {
    if (!cur || busy || cur.closing) return;
    if (root.clientWidth === cur.vw) return;
    fit(cur);
    pin(cur);
  });
})();
